export enum AvatarVariants {
  Circular = 'circular',
  Rounded = 'rounded',
  Square = 'square',
}
